var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"change-buttons"},[_c('el-button',{attrs:{"size":"small"},on:{"click":_vm.cancel}},[_vm._v("\n        Cancel\n    ")]),_c('el-button',{attrs:{"size":"small","type":"primary"},on:{"click":_vm.change}},[_vm._v("\n        "+_vm._s(_vm.getName)+"\n    ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }